module.exports = __webpack_public_path__ + "static/media/JS.4198aa0b.svg";